import { setLicense } from './license';

export function initAgGrid() {
  setLicense();
}
